module.exports = __webpack_public_path__ + "static/img/hala18.fa98f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala18.jpg
// module id = 3aXh
// module chunks = 1